<div class="desktop-detail-view">
  <div class="list">
    <ng-content select="itl-desktop-page-list"></ng-content>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
  <div class="actionBar" *ngIf="showActionBar">
    <ng-content  select="itl-desktop-page-action-item"></ng-content>
  </div> 
</div>
